<template>
  <div class="sidebar" :class="{ collapsed: isCollapsed }">
    <!-- 侧边栏头部 -->
    <div class="sidebar-header">
      <div class="sidebar-logo">
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="logo-icon">
          <circle cx="16" cy="16" r="14" fill="url(#heart-grad)"/>
          <path d="M16 10C13.5 7.5 9.5 7.5 7.5 10C5.5 12.5 5.5 16 7.5 18L16 26L24.5 18C26.5 16 26.5 12.5 24.5 10C22.5 7.5 18.5 7.5 16 10Z" fill="white" fill-opacity="0.95"/>
          <defs>
            <linearGradient id="heart-grad" x1="0" y1="0" x2="32" y2="32">
              <stop stop-color="#FF7E7E"/>
              <stop offset="1" stop-color="#FFA07A"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <h1 class="sidebar-title" v-show="!isCollapsed">时光同频</h1>
    </div>

    <!-- 菜单列表 -->
    <nav class="sidebar-menu">
      <ul>
        <li class="menu-group">
          <div class="menu-group-header" :class="{ active: $route.path.startsWith('/user-home') }" @click="toggleMenu('user')">
            <span class="menu-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </span>
            <span v-show="!isCollapsed" class="menu-label">用户中心</span>
            <span class="menu-arrow" :class="{ open: isOpen.user }" v-show="!isCollapsed">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </div>
          <ul class="submenu" v-show="isOpen.user && !isCollapsed">
            <li>
              <router-link to="/user-home" :class="{ active: $route.path === '/user-home' }">
                <span class="submenu-dot"></span>个人主页
              </router-link>
            </li>
          </ul>
        </li>

        <li class="menu-group">
          <div class="menu-group-header" :class="{ active: $route.path === '/' || $route.path.startsWith('/match') || $route.path.startsWith('/virtual') || $route.path.startsWith('/near') || $route.path.startsWith('/friend') }" @click="toggleMenu('chat')">
            <span class="menu-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            </span>
            <span v-show="!isCollapsed" class="menu-label">聊天交友</span>
            <span class="menu-arrow" :class="{ open: isOpen.chat }" v-show="!isCollapsed">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </div>
          <ul class="submenu" v-show="isOpen.chat && !isCollapsed">
            <li><router-link to="/" :class="{ active: $route.path === '/' }"><span class="submenu-dot"></span>聊天记录</router-link></li>
            <li><router-link to="/friend" :class="{ active: $route.path === '/friend' }"><span class="submenu-dot"></span>好友管理</router-link></li>
            <li><router-link to="/match/ai-recommend" :class="{ active: $route.path === '/match/ai-recommend' }"><span class="submenu-dot"></span>AI交友</router-link></li>
            <li><router-link to="/match/matched" :class="{ active: $route.path === '/match/matched' }"><span class="submenu-dot"></span>匹配推荐</router-link></li>
            <li><router-link to="/near" :class="{ active: $route.path === '/near' }"><span class="submenu-dot"></span>附近访客</router-link></li>
            <li><router-link to="/virtual-chat" :class="{ active: $route.path === '/virtual-chat' }"><span class="submenu-dot"></span>虚拟恋人</router-link></li>
          </ul>
        </li>

        <li class="menu-group">
          <div class="menu-group-header" :class="{ active: $route.path.startsWith('/membership') }" @click="toggleMenu('membership')">
            <span class="menu-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            </span>
            <span v-show="!isCollapsed" class="menu-label">会员中心</span>
            <span class="menu-arrow" :class="{ open: isOpen.membership }" v-show="!isCollapsed">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </div>
          <ul class="submenu" v-show="isOpen.membership && !isCollapsed">
            <li><router-link to="/membership/detail" :class="{ active: $route.path === '/membership/detail' }"><span class="submenu-dot"></span>会员详情</router-link></li>
            <li><router-link to="/membership/plans" :class="{ active: $route.path === '/membership/plans' }"><span class="submenu-dot"></span>开通会员</router-link></li>
          </ul>
        </li>

        <li class="menu-group">
          <div class="menu-group-header" :class="{ active: $route.path === '/checkin' }" @click="toggleMenu('checkin')">
            <span class="menu-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><polyline points="9 16 11 18 15 14"/></svg>
            </span>
            <span v-show="!isCollapsed" class="menu-label">每日签到</span>
            <span class="menu-arrow" :class="{ open: isOpen.checkin }" v-show="!isCollapsed">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </div>
          <ul class="submenu" v-show="isOpen.checkin && !isCollapsed">
            <li><router-link to="/checkin" :class="{ active: $route.path === '/checkin' }"><span class="submenu-dot"></span>签到中心</router-link></li>
          </ul>
        </li>

        <li class="menu-group">
          <div class="menu-group-header" :class="{ active: $route.path.startsWith('/product') || $route.path.startsWith('/cart') || $route.path.startsWith('/my-orders') || $route.path.startsWith('/seckill') }" @click="toggleMenu('mall')">
            <span class="menu-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            </span>
            <span v-show="!isCollapsed" class="menu-label">在线商城</span>
            <span class="menu-arrow" :class="{ open: isOpen.mall }" v-show="!isCollapsed">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </span>
          </div>
          <ul class="submenu" v-show="isOpen.mall && !isCollapsed">
            <li><router-link to="/products"><span class="submenu-dot"></span>在线商城</router-link></li>
            <li><router-link to="/my-orders"><span class="submenu-dot"></span>我的订单</router-link></li>
            <li><router-link to="/seckill"><span class="submenu-dot"></span>秒杀活动</router-link></li>
          </ul>
        </li>
      </ul>
    </nav>

    <!-- 底部收起按钮 -->
    <div class="sidebar-footer" @click="toggleCollapse">
      <div class="footer-divider"></div>
      <div class="collapse-btn">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :style="{ transform: isCollapsed ? 'rotate(180deg)' : '' }">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        <span v-show="!isCollapsed">收起菜单</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'

const isOpen = ref({
  user: false,
  chat: true,
  membership: false,
  checkin: false,
  mall: false
})

const toggleMenu = (key) => {
  isOpen.value[key] = !isOpen.value[key]
}

const isCollapsed = ref(false)
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value
}

const MOBILE_MAX = 768

const syncSidebarWidthVar = () => {
  if (typeof document === 'undefined') return
  const w = typeof window !== 'undefined' ? window.innerWidth : MOBILE_MAX + 1
  if (w <= MOBILE_MAX) {
    document.documentElement.style.setProperty('--app-sidebar-width', '0px')
  } else {
    document.documentElement.style.setProperty(
      '--app-sidebar-width',
      isCollapsed.value ? '68px' : '260px'
    )
  }
}

onMounted(() => {
  syncSidebarWidthVar()
  window.addEventListener('resize', syncSidebarWidthVar)
})

onUnmounted(() => {
  window.removeEventListener('resize', syncSidebarWidthVar)
})

watch(isCollapsed, syncSidebarWidthVar)
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100vh;
  height: 100dvh;
  background: linear-gradient(180deg, #1C1C2E 0%, #2A2A42 100%);
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 32px rgba(0, 0, 0, 0.12);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 99;
}

.sidebar.collapsed {
  width: 68px;
}

/* ── Header ── */
.sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.sidebar.collapsed .sidebar-header {
  padding: 20px 0;
  justify-content: center;
}

.sidebar-logo {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-icon {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 2px 4px rgba(255, 126, 126, 0.3));
}

.sidebar-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  background: linear-gradient(135deg, #FF7E7E, #FFA07A);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.03em;
}

/* ── Menu ── */
.sidebar-menu {
  flex: 1;
  padding: 10px 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-menu::-webkit-scrollbar {
  width: 3px;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 126, 126, 0.2);
  border-radius: 4px;
}

.sidebar-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-group {
  margin: 0 8px 2px;
  border-radius: 10px;
  overflow: hidden;
}

.menu-group-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9375rem;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.55);
  user-select: none;
}

.sidebar.collapsed .menu-group-header {
  padding: 10px 0;
  justify-content: center;
  margin: 0 4px;
}

.menu-group-header:hover {
  background: rgba(255, 126, 126, 0.08);
  color: rgba(255, 255, 255, 0.9);
}

.menu-group-header.active {
  background: rgba(255, 126, 126, 0.12);
  color: #fff;
}

.menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  color: currentColor;
}

.menu-label {
  flex: 1;
}

.menu-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  transition: transform 0.25s ease;
  opacity: 0.5;
}

.menu-arrow.open {
  transform: rotate(90deg);
}

/* ── Submenu ── */
.submenu {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  margin: 2px 4px 0;
  padding: 4px 0;
  overflow: hidden;
}

.submenu li {
  padding: 0;
  list-style: none;
}

.submenu a {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 8px 28px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  border-radius: 6px;
  margin: 0 4px;
}

.submenu a:hover {
  background: rgba(255, 126, 126, 0.06);
  color: rgba(255, 255, 255, 0.85);
}

.submenu a.active {
  background: rgba(255, 126, 126, 0.15);
  color: #FFA0A0;
  font-weight: 500;
}

.submenu-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.4;
  flex-shrink: 0;
}

.submenu a.active .submenu-dot {
  opacity: 1;
  background: #FF7E7E;
  box-shadow: 0 0 6px rgba(255, 126, 126, 0.5);
}

/* ── Footer ── */
.sidebar-footer {
  flex-shrink: 0;
  padding: 0 8px 12px;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin-bottom: 8px;
}

.collapse-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.35);
}

.sidebar.collapsed .collapse-btn {
  justify-content: center;
  padding: 10px 0;
}

.collapse-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.65);
}

.collapse-btn svg {
  transition: transform 0.3s ease;
}

@media (max-width: 768px) {
  .sidebar {
    width: min(280px, 86vw);
    z-index: 100;
  }

  .sidebar.collapsed {
    width: min(280px, 86vw);
  }
}
</style>
